import React, {Component} from 'react';
import {TopAlertInformacja, TopAlertUwaga} from "../../../../../../componentsTopsa/alerty/TopAlerts";
import DateAndTimeFormat from "../../../../../../utilities/DateAndTimeFormat";
import {Col, ProgressBar, Row} from "react-bootstrap";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import LSService from "../../../../../../utilities/localStorageService/LSService";
import {Link} from "react-router-dom";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";

export default class ObsadaListaModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderMiejsca = this.renderMiejsca.bind(this)
        this.onClickWyszukajBiletyNaKurs = this.onClickWyszukajBiletyNaKurs.bind(this)
    }

    componentDidMount() {
    }

    renderMiejsca(row = this.props.obsada) {

        let wszystkie = 25
        if (row.il_miejsc_kurs > 0) {
            wszystkie = row.il_miejsc_kurs
        }

        let ile_odbic = 0;
        if (Boolean(row.ile_odb_mies)) {
            ile_odbic = row.ile_odb_mies_popr
        }

        // wartości procentowe
        let zarezerwowane = 0
        let sprzedane = 0
        let skasowane = 0
        let miesieczne = 0

        if (row.il_rez > 0) {
            zarezerwowane = (row.il_rez * 100) / wszystkie
        }
        if (row.il_sprz > 0) {
            sprzedane = (row.il_sprz * 100) / wszystkie
        }
        if (row.il_skas > 0) {
            skasowane = (row.il_skas * 100) / wszystkie
        }
        if (ile_odbic > 0)
            miesieczne = (ile_odbic * 100) / wszystkie

        return (
            <div>
                {
                    (wszystkie - row.il_rez - row.il_sprz - row.il_skas - ile_odbic < 0) ?
                        <ProgressBar style={{marginBottom: '2px'}}>
                            <ProgressBar bsStyle="danger"
                                         now={(Math.abs(wszystkie - row.il_rez - row.il_sprz - row.il_skas - ile_odbic) * (100 / wszystkie))} key={1}
                                         style={{background: 'firebrick'}}/>
                        </ProgressBar>
                        :
                        <ProgressBar style={{marginBottom: '2px'}}>
                            <ProgressBar bsStyle="primary"
                                         style={{background: this.props.kolorRezerwacja}}
                                         now={zarezerwowane} key={1}/>
                            <ProgressBar bsStyle="success"
                                         style={{background: this.props.kolorSprzedany}}
                                         now={sprzedane} key={2}/>
                            <ProgressBar bsStyle="warning"
                                         style={{background: this.props.kolorSkasowany}}
                                         now={skasowane} key={3}/>
                            <ProgressBar bsStyle="warning"
                                         style={{background: "#61135e"}}
                                         now={miesieczne} key={4}/>
                        </ProgressBar>
                }
                <div style={{fontSize: '16px'}}>
                        <span title={'Ilość miejsc zarezerowanych'} className={'text-primary'}
                              style={{fontWeight: 'bold', cursor: 'pointer', color: this.props.kolorRezerwacja}}>
                           Rezerwacje: {row.il_rez}
                        </span>,
                    <span title={'Ilość miejsc sprzedanych'} className={'text-success'}
                          style={{marginLeft: '5px', fontWeight: 'bold', cursor: 'pointer', color: this.props.kolorSprzedany}}>
                           Sprzedane: {row.il_sprz}
                        </span>,
                    <span title={'Ilość skasowanych miejsc'}
                          style={{marginLeft: '5px', fontWeight: 'bold', cursor: 'pointer', color: this.props.kolorSkasowany}}>
                           Skasowane: {row.il_skas}
                        </span>,
                    <span title={'Ilość odbić miesięcznych poprawnych'}
                          style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: "#61135e"}}>
                           Odbić miesięcznych poprawnych: {ile_odbic}
                        </span>,
                    {
                        Boolean(row.ile_odb_mies_niepopr) &&
                        <span><span title={'Ilość odbić miesięcznych'}
                                    style={{marginLeft: '3px', fontWeight: 'bold', cursor: 'pointer', color: "red"}}>
                           Odbić niepoprawnych: {row.ile_odb_mies_niepopr}
                        </span>,</span>
                    }
                    {
                        (wszystkie - row.il_rez - row.il_sprz - row.il_skas < 0) ?
                            <span title={'Ilość brakujących miejsc'}
                                  style={{marginLeft: '5px', fontWeight: 'bold', cursor: 'pointer', color: 'firebrick'}}>
                           Brakujące: {(wszystkie - row.il_rez - row.il_sprz - row.il_skas)},
                        </span>
                            :
                            <span title={'Ilość wolnych miejsc'}
                                  style={{marginLeft: '5px', fontWeight: 'bold', cursor: 'pointer', color: '#222'}}>
                           Wolne: {(row.il_miejsc_kurs > 0) ? wszystkie - row.il_rez - row.il_sprz - row.il_skas : '?'},
                        </span>

                    }
                    {
                        Boolean(row.il_miejsc_kurs > 0) ?
                            <span title={'Ilość wszytskich miejsc'}
                                  style={{marginLeft: '15px', fontWeight: 'bold', cursor: 'pointer', color: 'grey'}}>
                           Wszystkie miejsca na kurs: {row.il_miejsc_kurs}
                        </span>
                            :
                            ''
                    }

                </div>
                {
                    (row.il_miejsc_kurs > 0) ?
                        (wszystkie - row.il_rez - row.il_sprz - row.il_skas < 0) ?
                            <div style={{color: 'firebrick', textAlign: 'center', marginTop: '15px', fontSize: '18px', fontWeight: 'bold'}}>
                                <i className={'fa fa-exclamation-circle'}></i> Brak wolnych miejsc - należy utworzyć kurs bisowy
                            </div>
                            :
                            ''
                        :
                        ''
                }
            </div>
        )
    }


    onClickWyszukajBiletyNaKurs(obj = this.props.obsada) {
        let params = {
            idTr: obj.id_tr,
            godz: obj.godz_1p,
            data: obj.data,
            idKu: obj.id_ku,
        }
        LSService.ustawWyszukiwanieBiletowZObsad(params);
    }

    renderTyp(cell, row) {

        return <span style={{fontSize: '12px'}}>
            {
                (cell === 0 || cell === 1) ?
                    'dokładnie od do'
                    :
                    'na całym odcinku'
            }
        </span>
    }

    formatWartosc(cell, row) {
        if (row.typ % 2 == 0) {
            return cell + ' PLN'
        }
        else return cell + ' %'
    }

    formatLimit(cell, row) {
        if (Boolean(cell)) {
            return cell
        } else return '-'
    }

    formatSprzedano(cell, row) {
        if (Boolean(row.ileBiletow)) {
            let pozostalo = parseInt(row.ileBiletow) - parseInt(cell)

            let procent = Math.ceil((parseInt(cell) * 100) / parseInt(row.ileBiletow))


            return (<div>
                <div style={{color: 'grey', fontStyle: 'italic', marginBottom: '3px'}}>
                    Sprzedano <span
                    style={{fontWeight: 'bold'}}>{cell}</span> z {row.ileBiletow} biletów ({procent}%)
                </div>
                <div>
                    {
                        (procent === 100) ?
                            <span className={'label label-danger'} style={{fontSize: 'inherit'}}>Wyprzedano bilety!</span>
                            :
                            (procent >= 90) ?
                                <span className={'label label-danger'} style={{fontSize: 'inherit'}}>Pozostało {pozostalo} biletów</span>
                                :
                                (procent >= 60) ?
                                    <span className={'label label-warning'} style={{fontSize: 'inherit'}}>Pozostało {pozostalo} biletów</span>
                                    :
                                    <span className={'label label-success'} style={{fontSize: 'inherit'}}>Pozostało {pozostalo} biletów</span>
                    }
                </div>
            </div>)
        }
        else
            return <span style={{color: 'grey', fontStyle: 'italic'}}>Sprzedano <span style={{fontWeight: 'bold'}}>{cell}</span> biletów</span>
    }

    render() {
        let typy = {
            0: "dokładnie od do PLN",
            1: "dokładnie od do %",
            2: "na całym odcinku PLN",
            3: "na całym odcinku %"
        }


        if (Boolean(this.props.obsada)) {
            return (
                <div>
                    <h3 style={{textAlign: 'center', marginTop: '0'}}>Informacje o sprzedaży na kursie <span className={'label label-ebus-primary'}
                                                                                                             style={{fontSize: 'inherit'}}>{this.props.obsada.id_ku}</span> {this.props.obsada.trasa},
                        odjazd o {DateAndTimeFormat.formatHHMM(this.props.obsada.godz_1p)}</h3>
                    <div style={{marginTop: '35px', marginBottom: '25px'}}>
                        <Row>
                            <Col xs={12} lg={10}>
                                {this.renderMiejsca()}
                            </Col>
                            <Col xs={12} lg={2}>
                                <Link to={'/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe'} target={'_blank'}>
                                    <TopButtonAction text={'Zobacz bilety'} iconType={'fa fa-external-link'} btnColor={'primary'} btnSize={'lg'}
                                                     onClick={() => {
                                                         this.onClickWyszukajBiletyNaKurs()
                                                     }}/>
                                </Link>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        {
                            Boolean(this.props.obsada.czy_promocja) ?
                                <div>
                                    <h4 style={{color: 'dodgerblue'}}><i className={'fa fa-tags'}></i> Ten kurs jest
                                        objęty {this.props.promocjeDlaKursu.length === 1 ? ' następującą promocją:' : ' następującymi promocjami:'}
                                    </h4>
                                    <div>
                                        <BootstrapTable data={this.props.promocjeDlaKursu}
                                                        hover
                                        >
                                            <TableHeaderColumn dataField='idPro' isKey hidden={false}
                                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} dataSort
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                            >ID Promocji</TableHeaderColumn>
                                            <TableHeaderColumn dataField='nazMiOd'
                                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                            >Od miejscowości</TableHeaderColumn>
                                            <TableHeaderColumn dataField='nazMiDo'
                                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                            >Do miejscowości</TableHeaderColumn>
                                            <TableHeaderColumn dataField='dataOd'
                                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                            >Od dnia</TableHeaderColumn>
                                            <TableHeaderColumn dataField='dataDo'
                                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                            >Do dnia</TableHeaderColumn>
                                            <TableHeaderColumn dataField='godzOd'
                                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} dataSort
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                               dataFormat={(cell, row) => {
                                                                   return cell.replace('.', ':')
                                                               }}
                                            >Od godz</TableHeaderColumn>
                                            <TableHeaderColumn dataField='godzDo'
                                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} dataSort
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                               dataFormat={(cell, row) => {
                                                                   return cell.replace('.', ':')
                                                               }}
                                            >Do godz</TableHeaderColumn>
                                            <TableHeaderColumn dataField='typ'
                                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} dataSort
                                                               filter={{type: 'SelectFilter', options: typy, selectText: ''}} formatExtraData={typy}
                                                               dataFormat={this.renderTyp}
                                            >Typ</TableHeaderColumn>
                                            <TableHeaderColumn dataField='wart' dataSort
                                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                               dataFormat={this.formatWartosc}
                                            >Wartość</TableHeaderColumn>
                                            <TableHeaderColumn dataField='ileBiletow'
                                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} dataSort
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                               dataFormat={this.formatLimit}
                                            >Limit biletów</TableHeaderColumn>
                                            <TableHeaderColumn dataField='ileBilSprz'
                                                               thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                                               filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                               dataFormat={this.formatSprzedano}
                                            >Sprzedaż</TableHeaderColumn>
                                        </BootstrapTable>

                                    </div>
                                </div>
                                :
                                ''
                        }
                    </div>
                </div>
            );
        }

        else {
            return <TopAlertUwaga text={'Nie można załadować danych sprzedaży'}/>
        }
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaLista/components/ObsadaListaModal.js